import { useContext, useEffect, useRef, useState } from "react";
import "./Header.css";
import { ConfigContext } from "../../assets/contexts/configContext";
import { Link, NavLink, useLocation } from "react-router-dom";
import {
  ABOUT_US_PAGE_LINK,
  CART_MAIN_LINK,
  CATALOG_ITEM_LINK,
  CATALOG_MAIN_LINK,
  CATEGORIES_PAGE_LINK,
  EN_SITE_URL,
  FAVORITE_LINK,
  PHONE,
  RU_SITE_URL
} from "../../assets/utils/constants";
import { CartIcon, CloseIcon, LAND_DROP_ARROW, LogoIcon, MenuIcon, SearchIcon } from "../../assets/icons/icons";
import mainApi from "../../assets/api/MainApi";
import CatalogDrop from "./CatalogDrop/CatalogDrop";
import MenuPopup from "./MenuPopup/MenuPopup";
import { CartContext } from "../../assets/contexts/cartContext";
import useScrollDirection from "../../assets/hooks/useScrollDirection";
import { getURLRelativePath, isExternalURL } from "../../assets/utils/utils";
import Search from "../Search/Search";
import useWindowSize from "../../assets/hooks/useWindowSize";
import { motion } from "framer-motion";
import { CallBackContext } from "../../assets/contexts/callBackContext";


function Header({ headerRef, blackBannerRef }) {
  const { setCallBackPopupOpen } = useContext(CallBackContext)
  const scrollDirection = useScrollDirection();
  const { width } = useWindowSize();
  const [searchOpen, setSearchOpen] = useState(false)

  const config = useContext(ConfigContext);
  const cart_context = useContext(CartContext)
  const {
    cart,
    handleAddToCart,
    handleRemoveFromCart,
    setCart,
  } = cart_context
  const { initialConstants } = config
  const { FIRST_LEVEL_CATEGORIES, HEADER_LINKS } = initialConstants

  const catalogBtnRef = useRef(null);
  const linksRef = useRef(null);

  const [isCatalogOpen, setCatalogOpen] = useState(false);
  // const [categories, setCategories] = useState(FIRST_LEVEL_CATEGORIES && FIRST_LEVEL_CATEGORIES.length > 0 && Array.isArray(FIRST_LEVEL_CATEGORIES) ? FIRST_LEVEL_CATEGORIES : []);
  const [topCategories, setTopCategories] = useState(undefined);

  // useEffect(() => {
  //   mainApi
  //     .getCategories({
  //       limit: 25,
  //       shop_id: "65ae789bcb5f6a9f66e457aa",
  //     })
  //     .then((res) => {
  //       console.log(res.data);
  //       setCategories(res.data);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  const [isMenuOpen, setMenuOpen] = useState(false);

  const [scrollWindowPosition, setScrollWindowPosition] = useState(0);
  const [popupScrollPosition, setPopupScrollPosition] = useState(0);

  const handleScroll = () => {
    const position = window.pageYOffset;

    setScrollWindowPosition(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.top = `-${scrollWindowPosition}px`;
      setPopupScrollPosition(scrollWindowPosition);
      setTimeout(() => {
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
        document.body.style.height = "100%";
      }, 10);

      console.log(window.pageYOffset);
    } else {
      document.body.style.overflow = "unset";
      document.body.style.position = "unset";
      document.body.style.width = "unset";
      document.body.style.height = "unset";
      document.body.style.top = `unset`;
      console.log(popupScrollPosition);
      window.scrollTo(0, popupScrollPosition);
      setScrollWindowPosition(popupScrollPosition);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMenuOpen]);

  const [visibleCategories, setVisibleCategories] = useState([]);

  useEffect(() => {
    if (!HEADER_LINKS || HEADER_LINKS.length === 0) return
    const updateVisibleLinks = () => {
      if (linksRef.current) {
        const maxAllowedWidth = linksRef.current.offsetWidth;
        if (maxAllowedWidth <= 0) return
        let totalWidth = 0;
        const linksToShow = [];

        HEADER_LINKS.forEach((link, index) => {
          const linkElement = document.createElement('div');
          linkElement.className = 'link';
          linkElement.style.visibility = 'hidden';
          linkElement.style.position = 'absolute';
          linkElement.innerText = link.name;
          document.body.appendChild(linkElement);
          const linkWidth = linkElement.offsetWidth + 28 * 2;
          document.body.removeChild(linkElement);

          if (totalWidth + linkWidth <= maxAllowedWidth) {
            linksToShow.push(link);
            totalWidth += linkWidth;
          }
        });

        setVisibleCategories(linksToShow);
      }
    };

    updateVisibleLinks();
    window.addEventListener('resize', updateVisibleLinks);

    return () => window.removeEventListener('resize', updateVisibleLinks);
  }, [HEADER_LINKS]);

  const [isLangOpen, setLangOpen] = useState(false)

  const location = useLocation()

  // useEffect(() => {
  //   // Update header styling dynamically
  //   if (headerRef.current) {
  //     if (headerIsOverBlack) {
  //       headerRef.current.classList.add('header--over-black');
  //     } else {
  //       headerRef.current.classList.remove('header--over-black');
  //     }
  //   }
  // }, [headerIsOverBlack, headerRef]);

  const langSelectorRef = useRef()

  useEffect(() => {
    // Only attach the listener if search is currently open
    if (!isLangOpen) return;

    const handleClickOutside = (e) => {
      // If the click is outside the searchRef area, close the search
      if (langSelectorRef.current && !langSelectorRef.current.contains(e.target)) {
        setLangOpen(false)
      }
    };

    // Attach the event listener
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener when the component unmounts or searchOpen changes
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isLangOpen, setLangOpen, langSelectorRef]);

  return (
    <>
      <header ref={headerRef} className={`header`}>
        <CatalogDrop
          isOpened={isCatalogOpen}
          setOpened={setCatalogOpen}
          categories={FIRST_LEVEL_CATEGORIES}
          catalogBtnRef={catalogBtnRef}
        />
        <MenuPopup
          isOpened={isMenuOpen}
          setOpened={setMenuOpen}
          categories={FIRST_LEVEL_CATEGORIES}
        />
        {console.log({
          loc: location.pathname,
          index: [CART_MAIN_LINK, CATALOG_ITEM_LINK].indexOf(location.pathname),
          arr: [CART_MAIN_LINK, CATALOG_ITEM_LINK],
        })}
        {[CART_MAIN_LINK, CATALOG_ITEM_LINK].some(segment => location.pathname.includes(segment)) ?
          null
          :
          <button
            className="header__bottom-menu"
            type="button"
            onClick={() => {
              setMenuOpen(true);
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M3 12H21M3 6H21M3 18H21" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        }

        <div className="header__content">

          <Link
            className="header__menu"
            to={`/${CATEGORIES_PAGE_LINK}`}
          >
            <svg className="header__menu-icon" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3 5C4.38071 5 5.5 3.88071 5.5 2.5C5.5 1.11929 4.38071 0 3 0C1.61929 0 0.5 1.11929 0.5 2.5C0.5 3.88071 1.61929 5 3 5ZM13 14C14.3807 14 15.5 12.8807 15.5 11.5C15.5 10.1193 14.3807 9 13 9C11.6193 9 10.5 10.1193 10.5 11.5C10.5 12.8807 11.6193 14 13 14ZM5.5 11.5C5.5 12.8807 4.38071 14 3 14C1.61929 14 0.5 12.8807 0.5 11.5C0.5 10.1193 1.61929 9 3 9C4.38071 9 5.5 10.1193 5.5 11.5ZM13 5C14.3807 5 15.5 3.88071 15.5 2.5C15.5 1.11929 14.3807 0 13 0C11.6193 0 10.5 1.11929 10.5 2.5C10.5 3.88071 11.6193 5 13 5Z" fill="white" />
            </svg>
          </Link>


          <Link to={'/'} className="header__logo">
            <LogoIcon
              mainClassName={'header__logo-img'}
              fillClassName={'header__logo-img-fill'}
            />
          </Link>
          <div className="header__cart-box">
            {cart && cart.length > 0 ? (
              <p className="header__cart-count">{cart.length}</p>
            ) : null}
            <Link className="header__cart" to={`/${CART_MAIN_LINK}`}>
              {/* <h3 className="header__cart-text">Корзина</h3> */}
              <svg className="header__cart-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M4.56203 9.50386C4.81224 7.50215 6.51384 6 8.53114 6H15.4689C17.4862 6 19.1878 7.50215 19.438 9.50386L20.438 17.5039C20.7364 19.8913 18.8749 22 16.4689 22H7.53114C5.12514 22 3.2636 19.8913 3.56203 17.5039L4.56203 9.50386Z" stroke="white" stroke-width="1.5" stroke-linejoin="round" />
                <path d="M9 16C11.3561 17.3404 12.6476 17.3263 15 16" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

            </Link>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
